import * as IndexService from '@/service/IndexService'
import * as NewVisitService from '@/service/NewVisitService'
import * as LiveService from '@/service/LiveService'
import * as types from '../mutation-types'
import mutation from '../mutation'

const state = {
	bannerList: [],
	indexVisitList: [],
	meetingList: [],
	liveList: [],
	webinarList: [],
	questionnaireList: [],
	pageSize: 10,
	pageNo: 1,
	showLoading: false,
  sceneUndoneObj: {},//每类的未完成个数
  // msgType: 0-普通消息 1-学术任务 2-品牌宣传 3-播客邀请 4-问卷调查 5-文章
  msgTypeObj: {
    0: '普通消息',
    1: '学术任务',
    2: '品牌宣传',
    3: '播客邀请',
    4: '问卷调查',
    5: '文章',
  },
  sceneTypeObj: {
    1: '趣课堂',
    4: '调研/病例',
    5: '趣直播',
    6: '多人会议',
    8: '学术拜访',
    9: '代表知识商城',
    10: '知识店铺',
    11: '知识项目',
    12: '医学播客',
  }
}
const getters = {
	bannerList: state => state.bannerList,
	meetingList: state => state.meetingList,
	indexVisitList: state => state.indexVisitList,
	questionnaireList: state => state.questionnaireList,
	showLoading: state => state.showLoading,
	sceneUndoneObj: state => state.sceneUndoneObj,
	pageSize: state => state.pageSize,
	liveList: state => state.liveList,
	webinarList: state => state.webinarList,
  msgTypeObj: state => {
    return (type) => {
      if (type !== 0 && !type) {
        return '其它'
      }
      return state.msgTypeObj[type] || '其它'
    }
  },
  sceneTypeObj: state => {
    return (type) => {
      if (type !== 0 && !type) {
        return '其它'
      }
      return state.sceneTypeObj[type] || '其它'
    }
  },
}
const mutations = {
	[types.GET_INDEX_BANNER](state, list) {
		state.bannerList = list.data
	},
	[types.GET_INDEX_VISIT_LIST](state, {
		pageNo,
		allList,
		list
	}) {
		state.indexVisitList = [...allList, ...list]
		state.pageNo = ++pageNo
	},
	[types.GET_INDEX_QUESTIONNAIRE_LIST](state, {
		pageNo,
		allList,
		list
	}) {
		state.questionnaireList = [...allList, ...list]
		state.pageNo = ++pageNo
	},
	[types.GET_INVITE_COUNT](state, res) {//meeting数量
		let obj = {}
		// 1、2已废弃 3老拜访 4新调研 5新趣课堂 6趣直播 7多人会议 8学术拜访 42 病例
		res.data.map(item => {
			if (item.type == 1) {
				obj.meetingUndone = item.count
			} else if (item.type == 2) {
				obj.surveyUndone = item.count
			} else if (item.type == 3) {
				obj.visitUndone = item.count
			} else if (item.type == 4) {
				obj.questionnaireUndone = item.count
			} else if (item.type == 5) {
				obj.conferenceUndone = item.count
			} else if (item.type == 6) {
				obj.liveUndone = item.count
			} else if (item.type == 7) {
				obj.webinarUndone = item.count
			} else if (item.type == 8) {
				obj.newVisitUndone = item.count
			} else if (item.type == 42) {
				obj.bingliUndone = item.count
			}
		})
		state.sceneUndoneObj = obj
	},
	[types.UPDATE_MEETING_LIST](state, {
		currentTime,
		meetingId
	}) {
		if (!state.meetingList) {
			state.meetingList = []
		}
		if (!state.inviteList) {
			state.inviteList = []
		}
		let newList = state.meetingList.map(item => {
			if (item.meetingId === meetingId) {
				item.viewTime = currentTime
			}
			return item
		})
		let inviteList = state.inviteList.map(item => {
			if (item.meetingId === meetingId) {
				item.viewTime = currentTime
			}
			return item
		})
		state.meetingList = newList
		state.inviteList = inviteList
	},
	[types.GET_INDEX_MEETING_LIST](state, { pageNo, allList, list }) {
		state.meetingList = [...allList, ...list]
		state.pageNo = ++pageNo
	},
	[types.GET_INDEX_LIVE_LIST](state, { pageNo, list }) {
		state.liveList = list
		state.pageNo = ++pageNo
	},
	[types.GET_INDEX_WEBINAR_LIST](state, { pageNo, list }) {
		state.webinarList = list
		state.pageNo = ++pageNo
	},
	[types.REQUEST_DOING](state) {
		state.showLoading = true
	},
	[types.REQUEST_CLOSE](state) {
		state.showLoading = false
	},
	[types.UPDATE_MEETING_LIST](state, data) {
		state.meetingList = state.meetingList.map(v => {
			if (v.sceneId === data.id && v.codeId === data.codeId) {
				v = { ...v, ...data.item }
			}
			return v
		})
	},
	[types.UPDATE_QUESTIONNAIRE_LIST](state, data) {
		state.questionnaireList = state.questionnaireList.map(v => {
			if (v.sceneId === data.id && v.codeId === data.codeId) {
				v = { ...v, ...data.item }
			}
			return v
		})
	},
	[types.UPDATE_LIVE_LIST](state, data) {
		state.liveList = state.liveList.map(v => {
			if (v.sceneId === data.id && v.codeId === data.codeId) {
				v = { ...v, ...data.item }
			}
			return v
		})
	},
	[types.UPDATE_NEW_VISIT_LIST](state, data) {
		state.indexVisitList = state.indexVisitList.map(v => {
			if (v.sceneId === data.id && v.codeId === data.codeId) {
				v = { ...v, ...data.item }
			}
			return v
		})
	},
	...mutation
}
const actions = {
	getIndexBanner({
									 commit,
									 state
								 }, areaType) {
		commit(types.REQUEST_DOING)
		return IndexService.getIndexBanner(areaType)
			.then((res) => {
				commit(types.REQUEST_CLOSE)
				commit(types.GET_INDEX_BANNER, res)
				return Promise.resolve(res)
			}, rea => {
				commit(types.REQUEST_CLOSE)
				return Promise.reject(rea)
			})
	},
	updateMeetingList({
											commit,
											state
										}, {
											currentTime,
											meetingId
										}) {
		commit(types.UPDATE_MEETING_LIST, {
			currentTime: currentTime,
			meetingId: meetingId
		})
	},
	initIndexVisitList({ commit, state }, { status }) {
		return IndexService.getNewVisitList(1, state.pageSize, status)
			.then(res => {
				let data = res.data && res.data.data
				commit(types.GET_INDEX_VISIT_LIST, { pageNo: 1, allList: [], list: data })
				return data
			}, rea => {
				return Promise.reject(rea)
			})
	},
	getIndexVisitList({ commit, state }, { status }) {
		return IndexService.getNewVisitList(state.pageNo, state.pageSize, status)
			.then(res => {
				let data = res.data && res.data.data
				commit(types.GET_INDEX_VISIT_LIST, {
					pageNo: state.pageNo,
					allList: state.indexVisitList,
					list: data
				})
				return data
			}, rea => {
				return Promise.reject(rea)
			})
	},
	initQuestionnaireList({ commit, state }, req) {
		return IndexService.getIndexQuestionnaireList({ pageNo: 1, pageSize: state.pageSize, ...req })
			.then(res => {
				commit(types.GET_INDEX_QUESTIONNAIRE_LIST, { pageNo: 1, allList: [], list: res.data.data })
				return res.data.data
			}, rea => {
				return Promise.reject(rea)
			})
	},
	getQuestionnaireList({ commit, state }, req) {
		return IndexService.getIndexQuestionnaireList({ pageNo: state.pageNo, pageSize: state.pageSize, ...req })
			.then(res => {
				commit(types.GET_INDEX_QUESTIONNAIRE_LIST, {
					pageNo: state.pageNo,
					allList: state.questionnaireList,
					list: res.data.data
				})
				return res.data.data
			}, rea => {
				return Promise.reject(rea)
			})
	},
	getInviteCount({ commit, state }) {
		return IndexService.inviteCount()
			.then(res => {
				commit(types.GET_INVITE_COUNT, res)
				return Promise.resolve(res)
			}, rea => {
				return Promise.reject(rea)
			})
	},
	initIndexMeetingList({ commit, state }, { status }) {
		return IndexService.getIndexMeetingList(1, state.pageSize, 'new', status)
			.then(res => {
				commit(types.GET_INDEX_MEETING_LIST, { pageNo: 1, allList: [], list: res.data.data })
				return res.data.data
			}, rea => {
				return Promise.reject(rea)
			})
	},
	getIndexMeetingList({ commit, state }, { status }) {
		return IndexService.getIndexMeetingList(state.pageNo, state.pageSize, 'new', status)
			.then(res => {
				commit(types.GET_INDEX_MEETING_LIST, {
					pageNo: state.pageNo,
					allList: state.meetingList,
					list: res.data.data
				})
				return res.data.data
			}, rea => {
				return Promise.reject(rea)
			})
	},
	initLiveList({ commit, state }, { sceneType, status }) {
		return LiveService.getIndexLiveList(1, state.pageSize, sceneType, status)
			.then(res => {
				commit(types.GET_INDEX_LIVE_LIST, { pageNo: 1, list: res.data.data })
				return res.data.data
			}, rea => {
				return Promise.reject(rea)
			})
	},
	getLiveList({ commit, state }, { sceneType, status }) {
		return LiveService.getIndexLiveList(state.pageNo, state.pageSize, sceneType, status)
			.then(res => {
				commit(types.GET_INDEX_LIVE_LIST, {
					pageNo: state.pageNo,
					list: [...state.liveList, ...res.data.data]
				})
				return res.data.data
			}, rea => {
				return Promise.reject(rea)
			})
	},
	initWebinarList({ commit, state }, { sceneType, status }) {
		return LiveService.getIndexLiveList(1, state.pageSize, sceneType, status)
			.then(res => {
				commit(types.GET_INDEX_WEBINAR_LIST, { pageNo: 1, list: res.data.data })
				return res.data.data
			}, rea => {
				return Promise.reject(rea)
			})
	},
	getWebinarList({ commit, state }, { sceneType, status }) {
		return LiveService.getIndexLiveList(state.pageNo, state.pageSize, sceneType, status)
			.then(res => {
				commit(types.GET_INDEX_WEBINAR_LIST, {
					pageNo: state.pageNo,
					list: [...state.webinarList, ...res.data.data]
				})
				return res.data.data
			}, rea => {
				return Promise.reject(rea)
			})
	},
	getNewVisitItem({ commit }, data) {
		return NewVisitService.getNewVisitItem(data).then(res => {
			const { data } = res
			return Promise.resolve(data || {})
		}, rea => {
			return Promise.reject(rea)
		})
	},
	submitNewExam({ commit }, data) {
		return NewVisitService.submitNewExam(data).then(res => {
			return Promise.resolve(res.data || {})
		}, rea => {
			return Promise.reject(rea)
		})
	},
	getSceneCode({ commit }, data) {
		return IndexService.getSceneCode(data).then(res => {
			return Promise.resolve(res.data || {})
		}, rea => {
			return Promise.reject(rea)
		})
	},
	updateIndexList({ commit }, data) {
		if (data.type === 'meeting') {
			commit(types.UPDATE_MEETING_LIST, data)
		} else if (data.type === 'questionnaire' || data.type === 'bingli') {
			commit(types.UPDATE_QUESTIONNAIRE_LIST, data)
		} else if (data.type === 'live' || data.type === 'webinar') {
			commit(types.UPDATE_LIVE_LIST, data)
		} else if (data.type === 'visit') {
			commit(types.UPDATE_NEW_VISIT_LIST, data)
		}
	}
}
export default {
	state,
	getters,
	actions,
	mutations
}
